import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/icon/icon-user-default.svg';
import _imports_1 from '@/assets/icon/icon-user-primary.svg';

const _withScopeId = n => (_pushScopeId("data-v-4b6644dc"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "list-wrapper"
};
const _hoisted_2 = {
  key: 0,
  class: "icon-rounded-wrapper"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "normal",
  src: _imports_0,
  alt: "user"
}, null, -1));

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "hover",
  src: _imports_1,
  alt: "user"
}, null, -1));

const _hoisted_5 = [_hoisted_3, _hoisted_4];
const _hoisted_6 = {
  key: 0,
  class: "dropdown-wrapper"
};
const _hoisted_7 = {
  class: "options-wrapper"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = ["src", "alt"];
const _hoisted_10 = {
  class: "font-subtitle2 text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "user-wrapper",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.checkStatus && $options.checkStatus(...args))
  }, [_renderSlot(_ctx.$slots, "icon", {}, () => [!$props.avatar ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5)) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    id: "user-nav-avatar",
    class: "avatar",
    style: _normalizeStyle(`background-image: url(${$props.avatar})`)
  }, null, 4))], true)]), $data.isOpen ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.list, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "option-wrapper cursor",
      key: `user-${item.name}`,
      onClick: $event => $options.change(item)
    }, [_createElementVNode("img", {
      src: item.img,
      alt: item.name
    }, null, 8, _hoisted_9), _createElementVNode("span", _hoisted_10, _toDisplayString(item.name), 1)], 8, _hoisted_8);
  }), 128))])])) : _createCommentVNode("", true)]);
}